/*列表页descript 折叠 */
    // 获取元素
    const textContainer = document.querySelector('.collection-banner__text-container-text');
    const readMoreLink = document.getElementById('readMoreLink');
    if(textContainer && readMoreLink){
        // 初始化状态
        let isExpanded = false;
        
        // 计算文本是否超过三行的函数
        function checkTextHeight() {
            // 创建临时元素来计算完整文本高度
            const tempElement = document.createElement('div');
            tempElement.style.visibility = 'hidden';
            tempElement.style.position = 'absolute';
            tempElement.style.width = textContainer.offsetWidth + 'px';
            tempElement.style.lineHeight = textContainer.style.lineHeight || '1.5';
            tempElement.style.fontSize = textContainer.style.fontSize || '16px';
            tempElement.innerHTML = textContainer.innerHTML;
            document.body.appendChild(tempElement);
            
            // 三行文本的高度
            const lineHeight = parseFloat(getComputedStyle(textContainer).lineHeight) || 24;
            const threeLinesHeight = lineHeight * 3;
            
            // 判断是否超过三行
            const isOverThreeLines = tempElement.offsetHeight > threeLinesHeight;
            
            // 移除临时元素
            document.body.removeChild(tempElement);
            
            return isOverThreeLines;
        }
        // 初始化文本显示状态
        function initTextDisplay() {
            const isOverThreeLines = checkTextHeight();
            
            if (isOverThreeLines) {
                // 超过三行，默认折叠
                textContainer.classList.add('text-collapsed');
                readMoreLink.classList.remove('link-hidden');
            } else {
                // 不足三行，显示全部内容，隐藏链接
                textContainer.classList.add('text-expanded');
                readMoreLink.classList.add('link-hidden');
            }
        }

        // 切换折叠/展开状态
        function toggleText() {
            if (isExpanded) {
                // 折叠状态
                textContainer.classList.remove('text-expanded');
                textContainer.classList.add('text-collapsed');
                readMoreLink.textContent = 'Read More';
                isExpanded = false;
            } else {
                // 展开状态
                textContainer.classList.remove('text-collapsed');
                textContainer.classList.add('text-expanded');
                readMoreLink.textContent = 'Read Less';
                isExpanded = true;
            }
        }

        // 绑定点击事件
        readMoreLink.addEventListener('click', toggleText);

        // 页面加载完成后初始化
        window.addEventListener('load', initTextDisplay);

        // 窗口大小变化时重新计算（可选）
        window.addEventListener('resize', initTextDisplay);
        
    }
    


    
function changeFrameHeight(){
        var ifm= document.getElementById("about-video"); 
        var tar = document.getElementById("mission-content"); 
        if(tar) {
          var width = tar.offsetWidth;
          var height= width/16*9+'px';
          var theight = (width/16*12)+'px';
          ifm.style.height=height;
          //tar.style.height=theight;
        }
       for(var ii=1;ii<7;ii++){
         var ifm= document.getElementById("creator-iframe-video"+ii); 
          var tar = document.getElementById("creator-video"+ii); 
          if(tar) {
            var width = tar.offsetWidth;
            var height= width/16*9+'px';
            var theight = (width/16*12)+'px';
            ifm.style.height=height;
            //tar.style.height=theight;
          }
       }

  var boxes = document.getElementsByClassName("creator-video");
  var inboxes = document.getElementsByClassName('tiktok-embed-give');
 
  if(inboxes){
     for(var titok =0;titok<boxes.length;titok++){
            var width = boxes[titok].offsetWidth;
            var height= width/9*16+'px';
            var theight = (width/9*17)+'px';
            inboxes[titok].style.height=height;
    }
  }
 
  
}

    window.onresize=function(){  
         changeFrameHeight();  

    } 
changeFrameHeight();

// 1. 获取所有 .des_content 下的 table 元素
const des_contenttables = document.querySelectorAll(".des_content table");

// 2. 核心判断：只有存在表格元素时才执行后续操作
if (des_contenttables.length > 0) {
  // 3. 遍历每个表格（用 for 循环保证最大兼容性，比如旧版浏览器）
  for (let i = 0; i < des_contenttables.length; i++) {
    const table = des_contenttables[i];
    
    // 4. 创建包裹用的 div 容器
    const wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper'; // 给容器添加类名
    
    // 5. 替换 DOM 节点：把表格替换成容器，再把表格放入容器内
    table.parentNode.replaceChild(wrapper, table);
    wrapper.appendChild(table);
  }
}